import styled from 'styled-components'
import { lighten, adjustHue } from 'polished'
import _MasteryLevelAvatar from '../../static/images/courses/masterylevel/master_level_avatar.svg'

export const MasteryLevelImage = styled.div`
  width: 100%;
  height: 75px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px 20px 0 0;
  background: url('${_MasteryLevelAvatar}'),
              linear-gradient(to top, ${props => lighten(0.12, `#${props.courseColor}`)}, ${props => adjustHue(350, lighten(0.22, `#${props.courseColor}`))});
  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-blend-mode: overlay;
`
